const DIRECTORY_API = {
	USERS: '/api/v1/users',
	GROUPS: '/api/v1/groups',
	ROLES: '/api/v1/roles',
	LMS_INSTANCES: '/api/v1/lms-instances'
};

export default DIRECTORY_API;
